"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mapSubjectPercentDiscount;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _calcPercentDiscountPrice = _interopRequireDefault(require("../utils/calcPercentDiscountPrice"));

var _createSubjectDiscounts = _interopRequireDefault(require("../createSubjectDiscounts"));

function mapSubjectPercentDiscount(_x, _x2, _x3, _x4, _x5) {
  return _mapSubjectPercentDiscount.apply(this, arguments);
}

function _mapSubjectPercentDiscount() {
  _mapSubjectPercentDiscount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(ctx, rule, subject, percentDiscount, discountProduct) {
    var prevPrice, quantity, nextPrice;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            prevPrice = subject.price, quantity = subject.quantity;
            nextPrice = (0, _calcPercentDiscountPrice.default)(prevPrice, percentDiscount);
            _context.t0 = _extends2.default;
            _context.t1 = {
              price: nextPrice
            };
            _context.next = 6;
            return (0, _createSubjectDiscounts.default)(ctx, rule, discountProduct, nextPrice - prevPrice, quantity);

          case 6:
            _context.t2 = _context.sent;
            return _context.abrupt("return", (0, _context.t0)(_context.t1, _context.t2));

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _mapSubjectPercentDiscount.apply(this, arguments);
}